// JS
import React, { useState, useEffect } from 'react';
//import { useGlobal } from 'reactn';
import { ErrorBoundary } from 'react-error-boundary';
import {
  renderHTMLspan,
  getInternationalPriceNuqlium,
  getCookieValue,
  brandUrl,
  devOrProd,
  isAppExclusive
  //calculateSaleDiscount
} from '../shared/utils';

// COMPS
import ProductSizes from '../ProductSizes';
import KlarnaNew from '../KlarnaNew';
import Clearpay from '../Clearpay';
import PayPal from '../PayPal';
import ProductShippingReturns from '../ProductShippingReturns';
import ProductGeneral from '../ProductGeneral';
import ColourSwatches from '../ColourSwatches';
import { LoadingSpinnerPDP } from '../LoadingSpinnerPDP';
import InStoreOnly from '../InStoreOnly';
import DeliveryEstimates from '../DeliveryEstimates';
//import ChristmasDeliveryCutoff from '../ChistmasDeliveryCutoff';
import AppExclusive from '../AppExclusive';

const checkForColour = (data) => {
  if (data.facolour) {
    return data.facolour[0].toLowerCase();
  } else if (data.colour) {
    return data.colour[0].toLowerCase();
  }
};

// COMP
const ProductDetails = ({
  data,
  gaAddToCartData,
  dataPDPMessage,
  reset,
  setReset,
  setSku,
  isMobile,
  setSupportApi,
  currency,
  generalInformation,
  shippingInformation,
  returnsInformation,
  userSession,
  blackFriday,
  isSale,
  swatchesProdArray,
  bfExcludedCategories,
  appExcludedCategories
}) => {
  const [prodSku, setProdSku] = useState(null);
  const [sizeSelect, setSizeSelect] = useState(null);
  const [sizeGuideSelect, setSizeGuideSelect] = useState(null);
  const [sizeError, setSizeError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [showFallback, setShowFallback] = useState(false);
  //const [globalState] = useGlobal();

  const checkSizeSelected = () => {
    !prodSku || !sizeSelect ? setSizeError('error') : setSizeError('');
    setTimeout(() => {
      setSizeError('');
    }, 3000);
  };

  // FOR BF PRICE CALCULATION //
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!data.product.option.price) {
        setShowFallback(true);
      }
      setIsLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, [data.product.option.price]);

  const calculateDiscountedPrice = (copy, percentage) => {
    const currencySymbol = data.product.option.price.match(/^[^\d]+/)[0];
    let locale;
    switch (currencySymbol) {
      case '£':
        locale = 'en-GB';
        break;
      case '€':
        locale = 'en-EU';
        break;
      case '$':
        locale = 'en-US';
        break;
      case '¥':
        locale = 'ja-JP';
        break;
      case 'AUD':
        locale = 'en-AU';
        break;
      default:
        locale = 'en-GB';
    }

    const priceStr = data.product.option.price
      .replace(/£|€|\$|¥|/g, '')
      .replace(/,/g, '');
    const priceNum = parseFloat(priceStr);
    if (isNaN(priceNum) || !isFinite(priceNum)) {
      return copy;
    }

    const discountedPrice = (priceNum * percentage).toFixed(2);
    const formattedPrice = Number(discountedPrice).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return `${currencySymbol}${formattedPrice}`;
  };

  const nqBrand = data.product.attributes.brand[0];

  const inStoreOnly = data.product.categorylist.some((cat) =>
    cat.includes('BR_SU')
  );

  return (
    <section
      className={
        isMobile
          ? 'container-fluid product-details-react'
          : 'container product-details-react'
      }
    >
      {data && data.product && (
        <>
          <div className="flex justify-between gap-x-2 mb-5 p-0 relative">
            <div className="flex flex-col w-9/12">
              <h1 className="product-title">
                <span className="brand-name">
                  {data?.product?.attributes?.brand[0] && (
                    <a
                      href={
                        nqBrand === 'côte&ciel'
                          ? '/brands/cote--ciel/'
                          : nqBrand === 'Porter - Yoshida & Co'
                          ? '/brands/porter-yoshida-co/'
                          : nqBrand === 'about:blank'
                          ? '/brands/aboutblank/'
                          : `/brands/${brandUrl(
                              data.product.attributes.brand[0]
                            )}/` + userSession
                      }
                      style={{ display: 'block' }}
                    >
                      {data.product.attributes.brand[0]}
                    </a>
                  )}
                </span>
                <span className="product-name">{data.product.name}</span>
              </h1>
              <p className="product-colour">
                {checkForColour(data.product.attributes)}
              </p>
            </div>

            {data.product.option.price ===
            data.product.option.promotionprice ? (
              <div className="flex flex-col w-3/12">
                <div className="flex items-end justify-end">
                  {blackFriday &&
                  data.product.categorylist.includes('WEB_BLK_FRI') &&
                  !bfExcludedCategories.some((el) =>
                    data.product.categorylist.includes(el)
                  ) ? (
                    <div className="product-price flex justify-center items-end">
                      <div className="blk-fri-price-tag">
                        <p>RRP </p>
                      </div>{' '}
                      {renderHTMLspan(data.product.option.price)}
                    </div>
                  ) : (
                    <div className="product-price">
                      {renderHTMLspan(data.product.option.price)}
                    </div>
                  )}
                </div>
                <div className="product-price code">
                  Code: {renderHTMLspan(data.product.productid)}
                </div>
              </div>
            ) : (
              <div className="flex flex-col w-3/12">
                <div className="flex items-end flex-wrap gap-x-2 justify-end">
                  <div className="product-price rrp">
                    {renderHTMLspan(data.product.option.price)}
                  </div>
                  <div className="product-price sale">
                    {renderHTMLspan(data.product.option.promotionprice)}
                  </div>
                </div>
                <div className="product-price code">
                  Code: {renderHTMLspan(data.product.productid)}
                </div>
              </div>
            )}
          </div>

          {isSale && devOrProd === 'dev' && data.product.option.onsale && (
            /*
              <div className="text-white uppercase text-lg font-bold inline-flex justify-center items-center text-center border-2 border-solid border-[#DA0018] mt-2 mb-2 p-0">
                <div className="w-1/2 lg:w-auto bg-[#DA0018] p-[10px]">Sale</div>
                <div className="bg-white text-[#DA0018] w-1/2 lg:w-auto p-[10px]">
                  {isLoading ? (
                    <LoadingSpinnerPDP isSale={isSale} />
                  ) : (
                    <>
                      Save {renderHTMLspan(calculateSaleDiscount(data.product))}
                    </>
                  )}
                </div>
              </div>
            */
            <div className="text-white uppercase text-base md:text-md font-bold inline-flex justify-start items-center gap-4 md:gap-3 my-2 p-0">
              <div className="w-auto bg-[#DA0018] p-[10px] rounded tracking-[1.3px] md:tracking-[1.6px]">
                Extra 15% Off Sale
              </div>
              <div className="text-black text-xs md:text-sm font-base w-auto lg:w-auto tracking-[0.22px] md:tracking-[0.24px]">
                Applied at checkout
              </div>
            </div>
          )}

          {/*
          isSale && data.product.categorylist.includes('SALE_MAIN') && (
            <div className="bg-[#DA0018] text-white font-sans inline-flex justify-center items-center mt-2 mb-2 border-2 border-solid border-[#DA0018] !p-0">
              <div className="flex flex-row items-center justify-center gap-2 text-white bg-[#DA0018] p-4 md:px-6 w-full md:w-fit leading-normal">
                <p className="text-md font-bold leading-normal tracking-normal flex flex-row gap-2 items-center">
                  Extra 15% Off
                </p>
              </div>
              <div className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                <span className="font-base leading-normal">Use Code</span>{' '}
                EXTRA15
              </div>
            </div>
          )*/}

          {blackFriday &&
            data.product.categorylist.includes('WEB_BLK_FRI') &&
            !bfExcludedCategories.some((el) =>
              data.product.categorylist.includes(el)
            ) && (
              <div className="bg-black text-white font-sans inline-flex justify-center items-center mt-2 mb-2 border-2 border-solid border-black !p-0">
                <div className="flex flex-row items-center justify-center gap-2 text-white bg-black p-4 md:px-6 w-full md:w-fit">
                  {isLoading ? (
                    <LoadingSpinnerPDP />
                  ) : (
                    <p className="text-md font-bold tracking-normal flex flex-row gap-2 items-center">
                      Cyber Week
                      <span className="leading-[19px]">
                        {calculateDiscountedPrice('25% OFF', 0.75) === '25% OFF'
                          ? ' '
                          : ''}
                        {renderHTMLspan(
                          calculateDiscountedPrice('25% OFF', 0.75)
                        )}
                      </span>{' '}
                    </p>
                  )}
                </div>
                <div className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                  <span className="font-base">Use Code</span> BF25
                </div>
              </div>
            )}

          {/*data.product.categorylist.includes('WEB_NIKE30') && (
            <div className="bg-black text-white font-sans inline-flex justify-center items-center mt-2 mb-2 border-2 border-solid border-black !p-0">
              <div className="flex flex-row items-center justify-center gap-2 text-white bg-black p-4 md:px-6 w-full md:w-fit">
                {isLoading ? (
                  <LoadingSpinnerPDP />
                ) : (
                  <p className="text-md font-bold tracking-normal flex flex-row gap-2 items-center">
                    <span className="leading-[19px]">
                      {calculateDiscountedPrice('30% OFF', 0.7) === '30% OFF'
                        ? ' '
                        : ''}
                      {renderHTMLspan(calculateDiscountedPrice('30% OFF', 0.7))}
                    </span>{' '}
                  </p>
                )}
              </div>
              <div className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                <span className="font-base">Use Code</span> NIKE30
              </div>
            </div>
          )*/}

          {/*data.product.categorylist.includes('WEB_CP30') && (
            <div className="bg-black text-white font-sans inline-flex justify-center items-center mt-2 mb-2 border-2 border-solid border-black !p-0">
              <div className="flex flex-row items-center justify-center gap-2 text-white bg-black p-4 md:px-6 w-full md:w-fit">
                {isLoading ? (
                  <LoadingSpinnerPDP />
                ) : (
                  <p className="text-md font-bold tracking-normal flex flex-row gap-2 items-center">
                    <span className="leading-[19px]">
                      {calculateDiscountedPrice('30% OFF', 0.7) === '30% OFF'
                        ? ' '
                        : ''}
                      {renderHTMLspan(calculateDiscountedPrice('30% OFF', 0.7))}
                    </span>{' '}
                  </p>
                )}
              </div>
              <div className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                <span className="font-base">Use Code</span> CP30
              </div>
            </div>
          )*/}

          {data.product.productid === '4109702' && (
            <div className="text-black uppercase text-xs lg:text-sm font-basemedium flex justify-center items-center mt-4 mb-2 lg:mt-7 lg:mb-10 p-0">
              <div className="w-auto bg-[#DBFFDF] p-6 rounded-md tracking-widest leading-6 lg:!leading-7">
                All proceeds from this sale will be donated to Nightsafe, a
                charity organization based in Blackburn that helps tackle youth
                homelessness in partnership with Gary Aspden. For more
                information on the amazing work by Nightsafe, click
                <a
                  href={'https://nightsafe.org/'}
                  style={{
                    display: 'inline-flex',
                    marginLeft: '5px',
                    textDecoration: 'underline'
                  }}
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
              </div>
            </div>
          )}

          {/*
          (data.product.option.priceasnumber ||
            data.product.option.promotionpriceasnumber) >= 50 && (
            <div className="bg-black text-white font-sans inline-flex justify-center items-center my-2 border-2 border-solid border-black !p-0">
              <p className="text-md font-bold leading-normal tracking-normal flex flex-row gap-2 items-center justify-center text-white bg-black p-4 md:px-6 w-full md:w-fit">
                &pound;1 Express Delivery
              </p>
              <p className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                <span className="font-base leading-normal ">Use Code</span> 1DEL
              </p>
            </div>
          )*/}

          {data.product.categorylist.includes('WEB_APP20') &&
            !appExcludedCategories.some((el) =>
              data.product.categorylist.includes(el)
            ) && (
              <div
                id="app-20-promo"
                className="hidden bg-[#EF8A53] text-white font-sans justify-center items-center my-2 border-2 border-solid border-[#EF8A53] !p-0"
              >
                <p className="text-md font-bold leading-normal tracking-normal flex flex-row gap-2 items-center justify-center text-white bg-[#EF8A53] p-4 md:px-6 w-full md:w-fit">
                  Download The App
                </p>
                <p className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                  20% Off{' '}
                  <span className="font-base leading-normal ">Full Price</span>
                </p>
              </div>
            )}

          {data.product.categorylist.includes('WEB_APP20') &&
            !appExcludedCategories.some((el) =>
              data.product.categorylist.includes(el)
            ) && (
              <div
                id="affiliate-20-promo"
                className="hidden bg-black text-white font-sans justify-center items-center my-2 border-2 border-solid border-black !p-0"
              >
                <p className="text-md font-bold leading-normal tracking-normal flex flex-row gap-2 items-center justify-center text-white bg-black p-4 md:px-6 w-full md:w-fit">
                  20% Off Full Price
                </p>
                <p className="flex flex-row items-center justify-center gap-2 text-md font-bold leading-normal tracking-normal text-black bg-white p-4 md:px-6 w-full md:w-fit">
                  <span className="font-base leading-normal ">Use Code</span>{' '}
                  SAVE20
                </p>
              </div>
            )}

          {isMobile && (
            <div className="mt-6 p-0">
              {devOrProd === 'dev' ? (
                isAppExclusive(data) ? (
                  // Render AppExclusive when isAppExclusive is true
                  <AppExclusive data={data} />
                ) : inStoreOnly ? (
                  // Render InStoreOnly when isAppExclusive is false and inStoreOnly is true
                  <InStoreOnly />
                ) : (
                  // Fallback when neither condition is true
                  <ErrorBoundary
                    fallback={
                      <div className="comp-error">
                        Error loading product sizes.
                      </div>
                    }
                  >
                    <ProductSizes
                      data={data}
                      gaAddToCartData={gaAddToCartData}
                      reset={reset}
                      prodSku={prodSku}
                      setProdSku={setProdSku}
                      isMobile={isMobile}
                      sizeError={sizeError}
                      setSizeError={setSizeError}
                      sizeSelect={sizeSelect}
                      setSizeSelect={setSizeSelect}
                      sizeGuideSelect={sizeGuideSelect}
                      setSizeGuideSelect={setSizeGuideSelect}
                      checkSizeSelected={checkSizeSelected}
                      currency={currency}
                      userSession={userSession}
                      swatchesProdArray={swatchesProdArray}
                    />

                    {/*
                      <ChristmasDeliveryCutoff
                        xmasCutOffPhase3={true}
                        cutoff={'Dec 23, 2024'}
                        time={'15:00'}
                      />
                    */}

                    {!inStoreOnly &&
                      getInternationalPriceNuqlium() === 'retail_gbp' && (
                        <>
                          <div className="pdp-general-message">
                            {dataPDPMessage?.pdp_message}
                          </div>
                          <div id="monetateHook" className="block"></div>
                        </>
                      )}

                    <DeliveryEstimates />
                  </ErrorBoundary>
                )
              ) : (
                // Fallback for non-dev environments
                <ErrorBoundary
                  fallback={
                    <div className="comp-error">
                      Error loading product sizes.
                    </div>
                  }
                >
                  <ProductSizes
                    data={data}
                    gaAddToCartData={gaAddToCartData}
                    reset={reset}
                    prodSku={prodSku}
                    setProdSku={setProdSku}
                    isMobile={isMobile}
                    sizeError={sizeError}
                    setSizeError={setSizeError}
                    sizeSelect={sizeSelect}
                    setSizeSelect={setSizeSelect}
                    sizeGuideSelect={sizeGuideSelect}
                    setSizeGuideSelect={setSizeGuideSelect}
                    checkSizeSelected={checkSizeSelected}
                    currency={currency}
                    userSession={userSession}
                    swatchesProdArray={swatchesProdArray}
                  />

                  {/*
                    <ChristmasDeliveryCutoff
                      xmasCutOffPhase3={true}
                      cutoff={'Dec 23, 2024'}
                      time={'15:00'}
                    />
                  */}

                  {!inStoreOnly &&
                    getInternationalPriceNuqlium() === 'retail_gbp' && (
                      <>
                        <div className="pdp-general-message">
                          {dataPDPMessage?.pdp_message}
                        </div>
                        <div id="monetateHook" className="block"></div>
                      </>
                    )}

                  <DeliveryEstimates />
                </ErrorBoundary>
              )}
            </div>
          )}

          <div className="payment-options">
            {(devOrProd === 'prod' ||
              (devOrProd === 'dev' && !isAppExclusive(data))) && (
              <>
                {/* PayPal */}
                {!inStoreOnly &&
                  getInternationalPriceNuqlium() === 'retail_gbp' && (
                    <PayPal data={data} />
                  )}

                {/* Klarna */}
                {(getInternationalPriceNuqlium() === 'retail_gbp' ||
                  getInternationalPriceNuqlium() === 'retail_eur') && (
                  <KlarnaNew
                    data={data}
                    currency={getCookieValue('currencypref')}
                  />
                )}

                {/* Clearpay */}
                {!inStoreOnly &&
                  getInternationalPriceNuqlium() === 'retail_gbp' && (
                    <Clearpay data={data} currency="GBP" />
                  )}
              </>
            )}
          </div>

          {!isMobile && (
            <>
              {devOrProd === 'dev' ? (
                <>
                  {isAppExclusive(data) ? (
                    <AppExclusive />
                  ) : inStoreOnly ? (
                    <InStoreOnly />
                  ) : (
                    <ErrorBoundary
                      fallback={
                        <div className="comp-error">
                          Error loading product sizes.
                        </div>
                      }
                    >
                      <ProductSizes
                        data={data}
                        gaAddToCartData={gaAddToCartData}
                        reset={reset}
                        prodSku={prodSku}
                        setProdSku={setProdSku}
                        isMobile={isMobile}
                        sizeError={sizeError}
                        setSizeError={setSizeError}
                        sizeSelect={sizeSelect}
                        setSizeSelect={setSizeSelect}
                        sizeGuideSelect={sizeGuideSelect}
                        setSizeGuideSelect={setSizeGuideSelect}
                        checkSizeSelected={checkSizeSelected}
                        currency={currency}
                        userSession={userSession}
                        swatchesProdArray={swatchesProdArray}
                      />

                      {/*
                        <ChristmasDeliveryCutoff
                          xmasCutOffPhase3={true}
                          cutoff={'Dec 23, 2024'}
                          time={'15:00'}
                        />
                      */}

                      <DeliveryEstimates />

                      {data && <ProductGeneral data={generalInformation} />}

                      <ProductShippingReturns
                        data={data}
                        shippingInformation={shippingInformation}
                        returnsInformation={returnsInformation}
                      />
                    </ErrorBoundary>
                  )}
                </>
              ) : (
                <ErrorBoundary
                  fallback={
                    <div className="comp-error">
                      Error loading product sizes.
                    </div>
                  }
                >
                  <ProductSizes
                    data={data}
                    gaAddToCartData={gaAddToCartData}
                    reset={reset}
                    prodSku={prodSku}
                    setProdSku={setProdSku}
                    isMobile={isMobile}
                    sizeError={sizeError}
                    setSizeError={setSizeError}
                    sizeSelect={sizeSelect}
                    setSizeSelect={setSizeSelect}
                    sizeGuideSelect={sizeGuideSelect}
                    setSizeGuideSelect={setSizeGuideSelect}
                    checkSizeSelected={checkSizeSelected}
                    currency={currency}
                    userSession={userSession}
                    swatchesProdArray={swatchesProdArray}
                  />

                  {/*
                    <ChristmasDeliveryCutoff
                      xmasCutOffPhase3={true}
                      cutoff={'Dec 23, 2024'}
                      time={'15:00'}
                    />
                  */}

                  <DeliveryEstimates />

                  {data && <ProductGeneral data={generalInformation} />}

                  <ProductShippingReturns
                    data={data}
                    shippingInformation={shippingInformation}
                    returnsInformation={returnsInformation}
                  />
                </ErrorBoundary>
              )}
            </>
          )}

          {isMobile && data && <ProductGeneral data={generalInformation} />}

          <ColourSwatches
            data={data}
            setSku={setSku}
            setSupportApi={setSupportApi}
            setReset={setReset}
            isMobile={isMobile}
            products={swatchesProdArray}
          />

          {isMobile && (
            <ProductShippingReturns
              data={data}
              shippingInformation={shippingInformation}
              returnsInformation={returnsInformation}
            />
          )}
        </>
      )}
    </section>
  );
};

export default ProductDetails;
